export default __webpack_public_path__ + "static/media/memories.4df3bcf9.png";